export const MainContent = ({ children }) => {
    return (
        <main className="pt-8 pb-16">
            <div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
                { children }
            </div>
        </main>
    )
}